<div class="d-flex d-md-flex justify-content-between align-items-center m-b-10">
  <fui-heading [text]="'Manage Beta Programs'" [level]="5"></fui-heading>
  <button class="btn btn-secondary" (click)="addEditBetaProgram()">
    <fa-icon icon="plus"></fa-icon>
    Add
  </button>
</div>
<div class="row">
  <div class="col-md-12">
    @if (betas && !betas.length) {
      <span class="t-16 d-block m-t-30 gothic text-center">No beta programs are currently scheduled.</span>
    }
    @if (loading) {
      <myp-inline-loader [loading]="true" height="200px" spinnerName="loader"></myp-inline-loader>
    }
    @if (betas && betas.length) {
      @for (item of betas; track item) {
        <myp-list-item
          [title]="item.title"
          [showImage]="false"
          [subData]="[
            [item.description.substring(0, 200) + '...'],
            item.start_date ? 'Starts ' + (item.start_date | date) : 'No start date.',
            item.end_date ? 'Ends ' + (item.end_date | date) : 'No end date.',
          ]"
          [item]="item"
          (itemClicked)="addEditBetaProgram(item)"
        >
          <div class="button-content">
            <button class="fa-button">
              <fa-icon icon="edit" placement="top" [ngbTooltip]="'Edit'" class="action circle-icon-btn m-r-5"></fa-icon>
              <span class="sr-only">Edit Beta Program</span>
            </button>
            <button class="fa-button" (click)="deleteBetaProgram(item); $event.stopPropagation()">
              <fa-icon icon="times" placement="top" [ngbTooltip]="'Delete'" class="action circle-icon-btn m-r-5"></fa-icon>
              <span class="sr-only">Delete Beta Program</span>
            </button>
          </div>
        </myp-list-item>
      }
    }
  </div>
</div>
